export const procesarFirmas = (firmaRef, firmaRefResponsable, requiereDobleFirma) => {
    const errores = [];
    const firmas = {};

    if (requiereDobleFirma) {
        // Doble firma: entrevistado y responsable
        if (!firmaRef || !firmaRef.current) {
            errores.push('Referencia de firma entrevistado no disponible');
            return { valido: false, errores, firmas };
        }
        const firmaEntrevistado = obtenerFirmaBase64(firmaRef);
        if (!firmaEntrevistado) {
            errores.push('Debe firmar el documento (firma entrevistado)');
            return { valido: false, errores, firmas };
        }
        firmas.firma_entrevistado = firmaEntrevistado;

        if (!firmaRefResponsable || !firmaRefResponsable.current) {
            errores.push('Referencia de firma responsable no disponible');
            return { valido: false, errores, firmas };
        }
        const firmaResponsable = obtenerFirmaBase64(firmaRefResponsable);
        if (!firmaResponsable) {
            errores.push('Debe firmar el documento (firma responsable)');
            return { valido: false, errores, firmas };
        }
        firmas.firma_responsable = firmaResponsable;
    } else {
        const firmaUnicaRef = (firmaRefResponsable && firmaRefResponsable.current)
            ? firmaRefResponsable
            : firmaRef;

        if (!firmaUnicaRef || !firmaUnicaRef.current) {
            errores.push('Referencia de firma no disponible');
            return { valido: false, errores, firmas };
        }

        const firmaUnica = obtenerFirmaBase64(firmaUnicaRef);
        if (!firmaUnica) {
            errores.push('Debe firmar el documento');
            return { valido: false, errores, firmas };
        }
        firmas.firma_responsable = firmaUnica;
    }

    return {
        valido: true,
        errores,
        firmas,
    };
};

const FIRMA_VACIA =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==';

const obtenerFirmaBase64 = (firmaRef) => {
    if (!firmaRef || !firmaRef.current) return null;
    if (typeof firmaRef.current.isEmpty === 'function' && firmaRef.current.isEmpty()) {
        return null;
    }
    const dataFirma = firmaRef.current.toDataURL();
    if (!dataFirma || dataFirma === FIRMA_VACIA) {
        return null;
    }
    const partes = dataFirma.split(',');
    return partes.length > 1 ? partes[1] : null;
};

/**
 * Firma del estudiante y firma del acudiente (traslado EPS).
 */
export const procesarFirmasEstudianteAcudiente = (firmaEstudianteRef, firmaAcudienteRef) => {
    const errores = [];
    const firmas = {};

    if (!firmaEstudianteRef || !firmaEstudianteRef.current) {
        errores.push('Referencia de firma del estudiante no disponible');
        return { valido: false, errores, firmas };
    }
    const firmaEstudiante = obtenerFirmaBase64(firmaEstudianteRef);
    if (!firmaEstudiante) {
        errores.push('Debe firmar el documento como estudiante');
        return { valido: false, errores, firmas };
    }
    firmas.firma_estudiante = firmaEstudiante;

    if (!firmaAcudienteRef || !firmaAcudienteRef.current) {
        errores.push('Referencia de firma del acudiente no disponible');
        return { valido: false, errores, firmas };
    }
    const firmaAcudiente = obtenerFirmaBase64(firmaAcudienteRef);
    if (!firmaAcudiente) {
        errores.push('Debe firmar el documento como acudiente o representante');
        return { valido: false, errores, firmas };
    }
    firmas.firma_acudiente = firmaAcudiente;

    return { valido: true, errores, firmas };
};
